import React from 'react';
import { ResetPasswordForm } from '../../toolympus/components/auth';

const ResetPasswordContainer = () => {
    return <ResetPasswordForm restoreAPIPath="/api/restore-access/reset" />
}

export default ResetPasswordContainer;